import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  container: {
    marginTop: '40px',
    maxWidth: '400px',
  },
  heading: {
    marginBottom: '6px',
  },
  description: {
    marginBottom: '16px',
  },
  fieldLabel: {
    marginBottom: '4px',
  },
  paragraphLabel: {
    marginTop: '20px',
    marginBottom: '4px',
  },
});
